import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchGroup } from 'focus_groups/ducks/view_state';
import {
  setStage, toggleVoting, setVoteIndex, identifyAnonymousUser
} from 'focus_groups/ducks/vote';
import partial from 'lodash/partial';

import Vote from 'focus_groups/components/vote';

export function mapStateToProps(state, { params }) {
  const viewState = idx(state, _ => _.project.focusGroups.viewState);
  const isVoting = idx(state, _ => _.project.focusGroups.vote.isVoting);
  const stage = idx(state, _ => _.project.focusGroups.vote.stage);

  return {
    stage,
    viewState,
    isVoting,
    isAnonymous: !!params.anonymousKey
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const { focusGroupId, participantKey, anonymousKey } = params;

  return bindActionCreators({
    fetch: partial(fetchGroup, focusGroupId, participantKey, anonymousKey),
    identify: partial(identifyAnonymousUser, focusGroupId, anonymousKey),
    toggleVoting,
    setVoteIndex,
    setStage,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Vote));



// WEBPACK FOOTER //
// ./focus_groups/containers/vote.js